import * as React from 'react';
import type { SVGProps } from 'react';
const SvgDocumentsSide = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 28 28"
    {...props}
  >
    <path
      stroke="#454655"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="m15.167 8.167-1.302-2.603c-.374-.75-.562-1.124-.84-1.398a2.3 2.3 0 0 0-.873-.538c-.37-.128-.788-.128-1.626-.128h-4.46c-1.306 0-1.96 0-2.458.254-.44.224-.796.581-1.02 1.02-.255.5-.255 1.153-.255 2.46v.933m0 0h17.734c1.96 0 2.94 0 3.689.381a3.5 3.5 0 0 1 1.53 1.53c.38.748.38 1.729.38 3.689V18.9c0 1.96 0 2.94-.38 3.689a3.5 3.5 0 0 1-1.53 1.53c-.749.381-1.729.381-3.69.381H7.935c-1.96 0-2.94 0-3.69-.381a3.5 3.5 0 0 1-1.529-1.53c-.381-.749-.381-1.729-.381-3.689zm8.167 8.166 2.334 2.334 5.25-5.25"
    />
  </svg>
);
export default SvgDocumentsSide;
